import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ICareplan, IRuleDescription, RULE_LEVEL } from "@comunicare/comunicare-interfaces";
import { RuleAlertService } from "src/app/providers/rule-alert.service";
import { SessionService } from "src/app/providers/session.service";

@Component({
  selector: "app-rules-list-modal",
  templateUrl: "./rules-list-modal.component.html",
  styleUrls: ["./rules-list-modal.component.scss"],
})
export class RulesListModalComponent implements OnInit {
  private rulesDescriptions: IRuleDescription[] = [];
  public careplanNames: string[];
  public rulesSimplified: {
    title?: string;
    level1: string[];
    level2: string[];
    level3: string[];
    careplans: string;
    nonEmptyLevels: { label: string; key: string }[];
  }[] = [];
  public displayedColumns: string[] = ["level", "description"];

  public levels = [
    { label: "page.preference.alerts.level.1", key: "level1" },
    { label: "page.preference.alerts.level.2", key: "level2" },
    { label: "page.preference.alerts.level.3", key: "level3" },
  ];
  public isAdmin = false;
  constructor(
    private ruleAlertService: RuleAlertService,
    private sessionService: SessionService,
    public dialogRef: MatDialogRef<RulesListModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { careplans: ICareplan[]; caremateId: string },
    private sanitizer: DomSanitizer
  ) {}
  ngOnInit(): void {
    this.isAdmin = this.sessionService.isAdmin();

    this.ruleAlertService.getRulesDescriptions(this.data.caremateId, this.sessionService.userLang).subscribe((r) => {
      this.rulesDescriptions = r;
      this.setupRulesSimplified();
    });
  }

  private setupRulesSimplified(): void {
    this.rulesDescriptions.forEach((rule) => {
      let simplifiedRule = this.rulesSimplified.find((r) => r.title === rule.title);

      if (!simplifiedRule) {
        simplifiedRule = {
          title: rule.title,
          level1: [],
          level2: [],
          level3: [],
          careplans: rule.careplans?.length ? rule.careplans.map((c) => c.display).join(", ") : "",
          nonEmptyLevels: [],
        };
        this.rulesSimplified.push(simplifiedRule);
      }

      rule.descriptions.forEach((desc) => {
        switch (desc.level) {
          case RULE_LEVEL.LOW:
            simplifiedRule.level1.push(desc.description);
            break;

          case RULE_LEVEL.MEDIUM:
            simplifiedRule.level2.push(desc.description);
            break;

          case RULE_LEVEL.HIGH:
            simplifiedRule.level3.push(desc.description);
            break;
        }
      });
    });

    this.rulesSimplified.forEach((simplifiedRule) => {
      simplifiedRule.nonEmptyLevels = [];
      if (simplifiedRule.level1?.length) {
        simplifiedRule.nonEmptyLevels.push(this.levels[0]);
      }
      if (simplifiedRule.level2?.length) {
        simplifiedRule.nonEmptyLevels.push(this.levels[1]);
      }
      if (simplifiedRule.level3?.length) {
        simplifiedRule.nonEmptyLevels.push(this.levels[2]);
      }
    });
  }
  public sanitize(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
